export function showConsoleMessage() {
  console.log(`
,ggg,        gg                                        ,g,
dP""Y8b       88           ,dPYb, ,dPYb,               888
Yb, \`88       88           IP'\`Yb IP'\`Yb               888
 \`"  88       88           I8  8I I8  8I               888
     88aaaaaaa88           I8  8' I8  8'               I8I
     88"""""""88   ,ggg,   I8 dP  I8 dP    ,ggggg,     I8I
     88       88  i8" "8i  I8dP   I8dP    dP"  "Y8gg"  \`8'
     88       88  I8, ,8I  I8P    I8P    i8'    ,8I
     88       Y8, \`YbadP' ,d8b,_ ,d8b,_ ,d8,   ,d8'    ,8,
     88       \`Y8888P"Y8888P'"Y888P'"Y88P"Y8888P"      \`8'
`);
  console.log(`
===========================================================
`);
  console.log(
    'Thanks for taking a look at my site. Would you like to see the source code for it? Enjoy!'
  );
  console.log('https://github.com/jhnsnc/2017-portfolio-site');
}
